<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary white--text">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider mame="Turma" rules="required" v-slot="{ errors }">
                    <e-label class="font-weight-medium">Turma</e-label>
                    <p class="font-weight-regular">
                      <v-select
                        :items="turmas"
                        :item-text="(item) => item.turma.descricao"
                        :item-value="(item) => item.turma.id"
                        :hint="turmaSelecionada?.franquia?.descricao || ''"
                        return-object
                        label="Selecione o campo abaixo"
                        v-model="turmaSelecionada"
                        @change="carregarGestaoSelecionada"
                        :error-messages="errors"
                      >
                        <template v-slot:selection="{ item }">
                          {{ item?.turma?.descricao || "" }}
                        </template>
                      </v-select>
                    </p>
                    </ValidationProvider>
                  </v-col>
                    <!-- {{ data_aula }}
                    {{ horarioSelecionado }} -->
                    <!-- {{ turmaSelecionada }} -->

                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="dataAulaDuplicada"
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <v-text-field
                          dense
                          solo
                          v-model="data_aula"
                          label="data"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        color="primary"
                        v-model="dataAulaDuplicada"
                        :allowed-dates="isDataPermitida"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(dataAulaDuplicada)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="gestaoDeAula.tipo_de_aula !== 'Aula Remota'"
                    cols="6"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horarios"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>


                </v-row>

                <v-row v-if="gestaoDeAula.e_aula_infantil === 1">
                  <v-col cols="12">
                    <e-label class="font-weight-regular mb-5"
                      >OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</e-label
                    >
                    <div
                      class="font-weight-regular"
                      v-html="gestaoDeAula.objetivos_aprendizagem_desenvolvimento"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-regular mb-5">OBJETO DE ESTUDO</e-label>
                    <div class="font-weight-regular" v-html="gestaoDeAula.objeto_estudo"></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-regular"
                      ><strong>ESTRATÉGIAS E AÇÕES / PRÁTICAS PEDAGÓGICAS </strong></e-label
                    >
                    <br />
                    <e-label>ACOLHIDA:</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.acolhida }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">ATIVIDADES:</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.atividade_classe }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">RECURSOS</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.recursos }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">AVALIAÇÃO</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.avaliacao }}
                    </p>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Conteúdo</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.conteudo }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Metodologia</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.metodologia }}
                    </p>
                  </v-col>
                </v-row>

                <template>
                  <v-row>
                    <v-col cols="12">
                      <v-alert color="primary" dense border="left">
                        <div class="font-weight-medium mb-2">Status de Preenchimento:</div>

                        <div class="d-flex align-center mb-1">
                          <v-icon :color="turmaSelecionada ? 'green darken-1' : 'grey'">
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2">Turma {{ turmaSelecionada ? 'Selecionada' : 'Não selecionada' }}</span>
                        </div>

                        <div class="d-flex align-center mb-1">
                          <v-icon :color="data_aula ? 'green darken-1' : 'grey'">
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2">Data da Aula {{ data_aula ? 'Selecionada' : 'Não selecionada' }}</span>
                        </div>

                        <div class="d-flex align-center mb-1">
                          <v-icon :color="horarioSelecionado ? 'green darken-1' : 'grey'">
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2">Horário {{ horarioSelecionado ? 'Selecionado' : 'Não selecionado' }}</span>
                        </div>

                        <v-progress-linear

                          :value="percentualPreenchido"
                          color="green"
                          height="20"
                          class="mt-4 mb-2"
                          rounded
                        >
                          <template v-slot:default="{ value }">
                            <strong>{{ Math.ceil(value) }}%</strong>
                          </template>
                        </v-progress-linear>
                      </v-alert>
                    </v-col>
                  </v-row>
                </template>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>

                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="percentualPreenchido < 100"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    />
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    // submittingForm: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      relacoesDiasHorarios: [],
      diasPermitidos: [],
      horarios: [],
      horarioSelecionado: null,
      dataAulaDuplicada: null,
      modal: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: null,
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },
      date: null,
    };
  },
  computed: {
    percentualPreenchido() {
      let totalCampos = 3;
      let preenchidos = 0;

      if (this.turmaSelecionada) preenchidos++;
      if (this.data_aula) preenchidos++;
      if (this.horarioSelecionado) preenchidos++;

      return (preenchidos / totalCampos) * 100;
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        if (val && val.horarios) {
          this.horarios = val.horarios;
        } else {
          this.horarios = [];
        }
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );
            this.turmas = gestoes;
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(novaData) {
      if (!novaData) return;
      const date = new Date(novaData);
      date.setHours(date.getHours() + 3);

      const dataFormatada = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "America/Fortaleza",
      }).format(date);

      this.data_aula = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(date);

      const diaDaSemana = date.getDay();
      const jsParaIdLaravel = {
        0: 0,
        1: 0,
        2: 1,
        3: 2,
        4: 3,
        5: 4,
        6: 5,
      };

      const idLaravel = jsParaIdLaravel.hasOwnProperty(diaDaSemana)
        ? jsParaIdLaravel[diaDaSemana]
        : null;

      this.horarios = this.relacoesDiasHorarios
        .filter((r) => r.dia.id === idLaravel)
        .map((r) => ({
          ...r.horario,
          descricao: `${r.horario.descricao}`,
          dia: r.dia,
        }));

      this.horarioSelecionado = null;
    },
  },

  methods: {
    isDataPermitida(date) {
      const diaJs = new Date(date).getDay();
      const mapa = {
        0: 0, // domingo → 6
        1: 1, // segunda → 0
        2: 2, // terça   → 1
        3: 3, // quarta  → 2
        4: 4, // quinta  → 3
        5: 5, // sexta   → 4
        6: 6, // sábado  → 5
      };
      const diaCustom = mapa[diaJs];
      const permitido = this.diasPermitidos.includes(diaCustom);
      return permitido;
    },
    async carregarGestaoSelecionada(selecionado) {
      if (!selecionado) return;

      try {
        this.$loaderService.open("Carregando informações da gestão");

        const infoGestao = await this.$services.gestoesDeAulasService.buscarGestaoDetalhada(
          selecionado.id
        );
        this.relacoesDiasHorarios = infoGestao.data;

        this.horarios = this.relacoesDiasHorarios.map((rel) => ({
          ...rel.horario,
          // dia: rel.dia, // opcional se você precisa do dia
        }));

        this.diasPermitidos = [...new Set(this.relacoesDiasHorarios.map((r) => r.dia.id))];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    enableSubmit() {
      this.confirmDialog = !this.confirmDialog;
      this.gestaoDeAula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.gestaoDeAula.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.gestaoDeAula.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.gestaoDeAula.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma_id;
        this.confirmDialog = false;

        this.$emit("dialogChange", false);

        await this.$services.aulasService.criar(this.gestaoDeAula);
        this.$toast.success("Aula exportada com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>
